const init = () => {
  const langEn = 'EN';
  const langNl = 'NL';
  const activeClass = 'site-switcher--switched';

  const switcher = document.getElementsByClassName('site-switcher');
  const switcherText = document.getElementsByClassName('site-switcher__lang');

  window.addEventListener('load', () => {
    Array.from(switcher).forEach((el) => {
      el.classList.remove('site-switcher--immediately');
    });
  });

  Array.from(switcher).forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      if (e.currentTarget.classList.contains(activeClass)) {
        e.currentTarget.classList.remove(activeClass);

        Array.from(switcherText).forEach((text) => {
          text.innerText = langNl;
        });
      } else {
        e.currentTarget.classList.add(activeClass);

        Array.from(switcherText).forEach((text) => {
          text.innerText = langEn;
        });
      }

      const href = e.currentTarget.href;

      const t = setTimeout(() => {
        clearTimeout(t);

        window.location.href = href;
      }, 250);
    });
  });
};

export default {
  init,
};
